(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crossx-g63-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('crossx-g63-comparison')) {
  customElements.define('crossx-g63-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', () => this.update());
      this.update();
      this.addEventListener('click', event => {
        const trigger=event.target.closest('[data-photo-index]');
        if(trigger){this.photoIndex=Number(trigger.dataset.photoIndex);this.photoTrigger=trigger;this.showPhoto();this.querySelector('dialog').showModal();}
        if(event.target.closest('[data-photo-close]'))this.querySelector('dialog').close();
        if(event.target.closest('[data-photo-prev]')){this.photoIndex=(this.photoIndex+9)%10;this.showPhoto();}
        if(event.target.closest('[data-photo-next]')){this.photoIndex=(this.photoIndex+1)%10;this.showPhoto();}
        if(event.target===this.querySelector('dialog'))this.querySelector('dialog').close();
      });
      this.querySelector('dialog').addEventListener('close',()=>this.photoTrigger?.focus());
    }
    showPhoto(){
      const source=this.querySelector('[data-photo-index="'+this.photoIndex+'"] img');
      const large=this.querySelector('[data-photo-large]');
      large.src=source.src;large.alt=source.alt;
      this.querySelector('[data-photo-caption]').textContent=source.alt;
      this.querySelector('[data-photo-count]').textContent=(this.photoIndex+1)+' / 10';
    }
    update() {
      const upgrade = this.querySelector('input[value="titanium"]:checked') ? Number(this.dataset.upgrade) : 0;
      const total = Number(this.dataset.base) + upgrade;
      const format = value => new Intl.NumberFormat('en-US', { style:'currency', currency:'USD', maximumFractionDigits:0 }).format(value);
      this.querySelectorAll('[data-total]').forEach(el => { el.textContent = format(total); });
      this.querySelector('[data-hardware-price]').textContent = format(upgrade);
      this.querySelector('[data-savings]').textContent = this.dataset.savingsTemplate.replace('__AMOUNT__', format(Number(this.dataset.oem) - total));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crossx-home"] && !Shopify.designMode) return;
  try {
    
function initCrossxBox(scope=document){scope.querySelectorAll('[data-package-contents]').forEach(box=>{if(box.dataset.ready)return;box.dataset.ready='true';const form=box.closest('.crossx-home').querySelector('.cx-build-form');const rotors=box.querySelector('[data-box-rotors]'),pads=box.querySelector('[data-box-pads]');const initial=[rotors.textContent,pads.textContent];const update=()=>{const value=form.querySelector('[data-build-option="Axle"]:checked')?.value;rotors.textContent=value?(value==='Front and rear'?box.dataset.four:box.dataset.pair):initial[0];pads.textContent=value?(value==='Front and rear'?box.dataset.twoSets:box.dataset.oneSet):initial[1];};form.addEventListener('change',update);form.addEventListener('reset',()=>queueMicrotask(update));update();});}
initCrossxBox();document.addEventListener('shopify:section:load',event=>initCrossxBox(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
